import script from "./DegradoPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DegradoPopup.vue?vue&type=script&setup=true&lang=js"

import "./DegradoPopup.vue?vue&type=style&index=0&id=585879d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585879d4"]])

export default __exports__